export const IMAGE_ROUTE = (path: string) => `https://static.wixstatic.com/${path}`;
